import { useEffect } from 'react';
import {
  chatActions,
  ChatType,
  useAppDispatch,
  useGetActiveHeroConversations,
  useGetArchivedHeroConversations,
} from '@vs-online-only-app/state';

const useSetActiveChatType = () => {
  const dispatch = useAppDispatch();
  const { data: activeConversations } = useGetActiveHeroConversations();
  const { data: archivedConversationPages } = useGetArchivedHeroConversations();

  const queryParameters = new URLSearchParams(window.location.search);
  const conversationIdParam = queryParameters.get('id');

  useEffect(() => {
    // Set the chat type and active conversation based on query parameters
    const getChatType = () => {
      if (
        conversationIdParam &&
        activeConversations &&
        archivedConversationPages
      ) {
        const activeConversationIds = activeConversations.map(({ id }) => id);
        const activeConversation = activeConversations.find(
          (c) => c.id === conversationIdParam,
        );

        if (activeConversation) {
          dispatch(chatActions.setSelectedConversation(activeConversation));
          return ChatType.Active;
        }

        const archivedConversations = archivedConversationPages.pages.flatMap(
          ({ conversations }) => conversations,
        );

        // Filter out archived conversations that are also active, old conversations that are restarted
        const filteredArchivedConversations = archivedConversations.filter(
          (c) => !activeConversationIds.includes(c.id),
        );

        const archivedConversation = filteredArchivedConversations.find(
          (c) => c.id === conversationIdParam,
        );

        if (archivedConversation) {
          dispatch(chatActions.setSelectedConversation(archivedConversation));
          return ChatType.Archived;
        }
      }

      return ChatType.Active;
    };

    // Set the determined chat type
    const chatType = getChatType();
    dispatch(chatActions.setSelectedChatType(chatType));

    // Run only on initial render since we don't want
    // to run this effect when the active chat updates,
    // i.e. when a new message is received
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useSetActiveChatType;
